import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsPaginationDisplay = styled<any, any>(
    'div',
    'documentsPaginationDisplay',
    'documentsGrid'
)`
    ${propStyles};
`;

DocumentsPaginationDisplay.defaultProps = {
    display: 'flex',
    alignItems: 'center',
};

export default DocumentsPaginationDisplay;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsPaginationDisplay.tsx